export default function Footer() {
  return (
    <footer className="siteFooter">
      © 2026 &lt;被寫體&gt; All rights reserved{" "}
      <br />
      Designed by bold (
      <a
        href="https://twitter.com/nonairr"
        target="_blank"
        rel="noreferrer"
        className="footerLink"
      >
        @nonairr
      </a>
      )
    </footer>
  );
}